// you can also type rafc or rfce to shorten code by combining the export line with function
import React from 'react'
import './contact.css'
import {ImLinkedin} from 'react-icons/im'
import {ImGithub} from 'react-icons/im'


export default function Contact() {
  return (
    // to link the icons to take you to corresponding section
<section id="contact" class="contact">
  <div class="contact-header">
  <h5>Get in touch </h5>
    <h2>Contact Me</h2>
  </div> 
  
  <div class="contact-content">
    <div class="contact-form">
      <h3 id="form-title">Send me a message</h3>
    <form action="mailto:gousesyed97@gmail.com" method="post" enctype="text/plain">
      <fieldset>
        <div class="form-field">
          <input name="name" type="text" id="name" placeholder="Your Name"></input>
        </div>
      <div class="form-field">
          <input name="email" type="email" id="email" placeholder="Your Email"></input>
        </div>
      <div class="form-field">
          <input name="Subject" type="text" id="subject" placeholder="Subject"></input>
        </div>
    <div class="form-field">
          <textarea name="message" type="text" id="message" placeholder="Your Message"></textarea>
        </div>
      </fieldset>
  <input id="form-btn" type="submit" value="send"></input>
    </form>
</div>
  
    <div class="contact-info">
      <h3 id="contact-phone" >Email Me At </h3>
      <a href="mailto:gousesyed97@gmail.com" id="maill">gousesyed97@gmail.com</a> 
      <h3 id="contact-phone" >Reach me At</h3>
      <a href="tel:9666">+91 9666758335</a>
      <h3>Find Me On </h3>
      <div class="contact-links">
      <a href="https://www.linkedin.com/in/mohammad-gouse-syed-9751a5160/" target="blank" rel="noreferrer" class="fab"  id="contact-linkedin" ><ImLinkedin/></a>
      <a href="https://github.com/syed2605" target="_blank" rel="noreferrer" class="fab" id="contact-github" ><ImGithub/></a>
      </div>
    </div>
    </div>
</section>

  )
}
